import easyfyHttpClient from '@shared/easyfy.httpclient';

namespace Easyfy.Web.Services.Component {
  export interface IContactUsData {
    name: string;
    sendemailto: string;
    message: string;
    customerEmail: string;
    subject: string;
    phone?: string;
    orderNumber?: string;
  }

  export interface IReviewListData {
    productid: string;
    page: number;
    pageSize: number;
  }

  export const ContactUs = async (data: IContactUsData, token: string): Promise<any> => {
    return await easyfyHttpClient.post(`/api/contactus?handler=sendmessage`, data, token);
  };

  export const ReviewListGetMore = async (data: IReviewListData, token: string): Promise<any> => {
    return await easyfyHttpClient.post(`/api/reviewlist?handler=getmorereviews`, data, token);
  };
}

export default Easyfy.Web.Services.Component;
